import React, { useCallback, useEffect, useState } from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { icons } from '~/assets';
import * as St from './styles';

export interface IDrop {
  onFileUploaded?: (file: File) => void;
  clearFileStatus?: boolean;
  dropZoneOptions?: DropzoneOptions;
  containerStyle?: React.CSSProperties;
  label?: string;
  accept?: string;
}

const LocalDropzone: React.FC<IDrop> = ({
  onFileUploaded,
  clearFileStatus = false,
  dropZoneOptions,
  label = 'Faça upload',
  containerStyle,
  accept = 'image/*',
}) => {
  const [selectedFileUrl, setSelectedFileUrl] = useState('');
  const [selectedFileName, setSelectedFileName] = useState('');

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      const fileUrl = URL.createObjectURL(file);
      setSelectedFileUrl(fileUrl);
      setSelectedFileName(file.name);
      onFileUploaded(file);
    },
    [onFileUploaded],
  );
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    ...dropZoneOptions,
  });
  useEffect(() => {
    if (clearFileStatus) {
      onFileUploaded(null);
      setSelectedFileUrl('');
    }
  }, [clearFileStatus]);

  return (
    <St.Container style={containerStyle} {...getRootProps()}>
      <St.DropInput {...getInputProps()} accept={accept} />
      {clearFileStatus}
      {selectedFileUrl ? (
        <St.PreLoadImage src={selectedFileUrl} alt={selectedFileName} />
      ) : (
        <St.DropSpan>
          <St.Icon src={icons.uploadFileIcon} />
          {label}
        </St.DropSpan>
      )}
    </St.Container>
  );
};

export default LocalDropzone;
